'use client';
import React, { useMemo } from 'react';
import { IEvaluation } from '@/lib/evaluationsApi';
import { TEvaluationModel, TModelDeveloper } from '@/lib/evaluationModelsApi';

import { Row } from '@/ui/primatives';
import Input from '@/components/Input';
import LogoIcon from '@/components/EvaluationModels/LogoIcon';
import * as Styled from './styled';
import { FieldError, Control } from 'react-hook-form';

const disabledIconStyles = { opacity: 0.25 };

const ModelOption: React.FC<{ model: TEvaluationModel; disabled?: boolean }> = ({ model, disabled }) => {

  return (
    <Row gap={10} alignItems="center">
      <LogoIcon
        logoUrl={model.developer?.logo}
        name={model.developer?.display_name || model.developer?.name || '?'}
        height={16}
        style={disabled ? disabledIconStyles : {}}
      />

      <div>{model.display_name || model.name}</div>
    </Row>
  );
};

const ModelSelectOption = (props: any) => {
  const { innerProps, isDisabled, data, getStyles } = props;
  const model: TEvaluationModel = data.model;
  const baseStyles = getStyles('option', props);
  const styles = props.type === 'option' ? baseStyles : { ...baseStyles, paddingLeft: 4 };
  // return !isDisabled ? (
  return (
    <Styled.ModelSelectOption style={styles} {...innerProps}>
      <ModelOption model={model} disabled={isDisabled} />
      <div className="option-provider">
        <small className="dim">Inferrence provider: {model.provider.display_name || model.provider.name}</small>
      </div>
    </Styled.ModelSelectOption>
  );
};

const ModelValueOption = (props: any) => {
  const { innerProps, isDisabled, data, getStyles } = props;
  const model: TEvaluationModel = data.model;
  const baseStyles = getStyles('option', props);
  const styles = props.type === 'option' ? baseStyles : { ...baseStyles, paddingLeft: 4 };
  // return !isDisabled ? (
  return (
    <div style={styles} {...innerProps}>
      <ModelOption model={model} disabled={isDisabled} />
    </div>
  );
};

const getModelOptions = (options: TEvaluationModel[]) => {
  return options.map((model) => ({
    value: model.id,
    label: model.display_name || model.name,
    model: model,
  }));
};

const ModelSelect: React.FC<{
  name: string;
  label?: string;
  options: TEvaluationModel[];
  control: Control<any, any>;
  error?: FieldError;
  disabled?: boolean;
  defaultIcon?: {
    logoUrl?: string;
    displayName?: string;
    name?: string;
  };
}> = React.memo(({ name, label = 'Model', options, control, error, disabled, defaultIcon, ...rest }) => {
  const modelOptions = useMemo(() => getModelOptions(options), [options]);
  return (
    <Input.Select
      // menuIsOpen={true}
      name={name}
      label={label}
      placeholder="Select model"
      error={error}
      control={control}
      options={modelOptions}
      prefixElement={
        defaultIcon && (
          <LogoIcon
            logoUrl={defaultIcon?.logoUrl}
            name={defaultIcon?.displayName || defaultIcon?.name || '?'}
            height={16}
            style={disabled ? disabledIconStyles : {}}
          />
        )
      }
      customComponents={{ Option: ModelSelectOption, disabled: ModelValueOption }}
      wide
      {...rest}
    />
  );
});

export default ModelSelect;
